module.exports = __webpack_public_path__ + "static/empty-1e261331a45b0df016c127f766b5cd69.png";